import type { VignetteDefinition } from "./types";

/**
 * A rare special event — a glowing bubble washes ashore with a mermaid
 * inside (see MermaidVisitor.ts and assets-pipeline/ASSET_SOURCING.md for
 * why it's specifically "in a bubble": the plain-figure model tried first
 * imported broken). "Wave" stands in for Johnny's reaction (no dedicated
 * "MermaidReact" animation exists yet — see fishing.vignette.ts's note on
 * the same gap).
 */
export const mermaidVisitVignette: VignetteDefinition = {
  id: "mermaid-visit",
  name: "A mermaid arrives in a bubble",
  category: "rare",
  weight: 1, // low relative to fishing's 10 — see SceneDirector's weighted pool
  animationClip: "Wave",
  loopAnimation: true,
  durationMs: 6000,
  cameraFraming: {
    // Framed toward the midpoint between Johnny and the bubble's fixed
    // spawn spot (see SceneRoot.ts's mermaidSpot), pulled back along the
    // opposite diagonal so both are in view together.
    offset: { x: -2.5, y: 2, z: -2 },
    targetOffset: { x: 1.25, y: 0.7, z: 1.0 },
  },
  audioCues: [],
  timeOfDay: "day",
  onEnter: (ctx) => ctx.mermaid.show(),
  onExit: (ctx) => ctx.mermaid.hide(),
};
